import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { Reward, RewardFilter, RewardsPayload, RewardStateFilterType, RewardUpdatePayload } from "./reward.model";

export const ACTION_PREFIX = "[Reward]";

export const REWARD_ACTION_TYPE = {
	get: `${ACTION_PREFIX} Get`,
	getSuccess: `${ACTION_PREFIX} Get Success`,
	getFail: `${ACTION_PREFIX} Get Fail`,

	getAll: `${ACTION_PREFIX} Get All`,
	getAllSuccess: `${ACTION_PREFIX} Get All Success`,
	getAllFail: `${ACTION_PREFIX} Get All Fail`,

	claim: `${ACTION_PREFIX} Claim`,
	claimSuccess: `${ACTION_PREFIX} Claim Success`,
	claimFail: `${ACTION_PREFIX} Claim Fail`,

	clear: `${ACTION_PREFIX} Clear ${SYNC_SUFFIX}`,

	forfeit: `${ACTION_PREFIX} Forfeit`,
	forfeitSuccess: `${ACTION_PREFIX} Forfeit Success`,
	forfeitFail: `${ACTION_PREFIX} Forfeit Fail`,
};

/**
 * @deprecated [fabric-deprecated] - Use fabric RewardService from app-account instead
 */
@Injectable({
	providedIn: "root",
})
export class RewardAction {
	/**
	 * @deprecated [fabric-deprecated] - use fabric RewardService - AccountAppValue.GetRewards from app-account instead
	 */
	getRewards(payload?: RewardStateFilterType[]): ActionWithPayload {
		return {
			type: REWARD_ACTION_TYPE.getAll,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - use fabric RewardService - AccountAppValue.GetRewards from app-account instead
	 */
	getRewardsSuccess(payload: RewardsPayload): ActionWithPayload {
		return {
			type: REWARD_ACTION_TYPE.getAllSuccess,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - use fabric RewardService - AccountAppValue.GetRewards from app-account instead
	 */
	getRewardsFail(error: AppError): ActionWithPayload {
		return {
			type: REWARD_ACTION_TYPE.getAllFail,
			payload: error,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - use fabric RewardService - AccountAppValue.GetReward from app-account instead
	 */
	getReward(payload?: RewardFilter): ActionWithPayload {
		return {
			type: REWARD_ACTION_TYPE.get,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - use fabric RewardService - AccountAppValue.GetReward from app-account instead
	 */
	getRewardSuccess(payload: Reward): ActionWithPayload {
		return {
			type: REWARD_ACTION_TYPE.getSuccess,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - use fabric RewardService - AccountAppValue.GetReward from app-account instead
	 */
	getRewardFail(error: AppError): ActionWithPayload {
		return {
			type: REWARD_ACTION_TYPE.getFail,
			payload: error,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - use fabric RewardService -AccountAppCommand.ClearRewards from app-account instead
	 */
	clearRewards(payload?: RewardStateFilterType): ActionWithPayload {
		return {
			type: REWARD_ACTION_TYPE.clear,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - use fabric RewardService -AccountAppCommand.ClaimReward from app-account instead
	 */
	claimReward(payload: RewardUpdatePayload): ActionWithPayload {
		return {
			type: REWARD_ACTION_TYPE.claim,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - use fabric RewardService -AccountAppCommand.ClaimReward from app-account instead
	 */
	claimRewardSuccess(): Action {
		return {
			type: REWARD_ACTION_TYPE.claimSuccess,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - use fabric RewardService -AccountAppCommand.ClaimReward from app-account instead
	 */
	claimRewardFail(error: AppError): ActionWithPayload {
		return {
			type: REWARD_ACTION_TYPE.claimFail,
			payload: error,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - use fabric RewardService -AccountAppCommand.ForfeitReward from app-account instead
	 */
	forfeitReward(payload: Reward): ActionWithPayload {
		return {
			type: REWARD_ACTION_TYPE.forfeit,
			payload,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - use fabric RewardService -AccountAppCommand.ForfeitReward from app-account instead
	 */
	forfeitRewardSuccess(): Action {
		return {
			type: REWARD_ACTION_TYPE.forfeitSuccess,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - use fabric RewardService -AccountAppCommand.ForfeitReward from app-account instead
	 */
	forfeitRewardFail(error: AppError): ActionWithPayload {
		return {
			type: REWARD_ACTION_TYPE.forfeitFail,
			payload: error,
		};
	}
}
